module.exports = __webpack_public_path__ + "img/activeip.985326ac.svg";